module.exports = "../study/imgs/maps/Kanagawa/GWQ8/Climate/SwelteringNight/Kanagawa_SwelteringNight_MRI_RCP85_End.png";